"use client";

import { z } from "zod";
import { FormEvent, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react";
import shiraz from "@/assets/hello/shiraz.png"
import farhangiyan from "@/assets/hello/studentpng.parspng.com-2.png"
import pencel from "@/assets/hello/pencel.png"
import goniya from "@/assets/hello/goniya.png"
import posterfilm from "@/assets/hello/postervideo.png"
import Image, { StaticImageData } from "next/image";
import { submitTeacherTrainingRegistration } from "@/actions/submitTeacherTrainingRegistration";
import toast from "react-hot-toast";
import { useUser } from "@/context/UserContext";
import AuthStepController from "@/components/auth/AuthStepController";
import Select, { InputProps } from 'react-select'
import { birthDay, birthMonths, birthYear, Cities, Ostan, TeachingExperience, TeachingGrades, Work } from "./data";
import { useCart } from "@/context/CartContext";
import { getCartData } from "@/core/apiCalls/cart";
import { Calendar1, CalendarRange, CircleCheck, MoveLeft, Tags, Wallet } from "lucide-react";
import saminIcon from "@/assets/hello/samin.png"
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import {
    birthDateSchema,
    createAdlandLandingRequestSchema,
    emptyEmailSchema,
    mobilePhoneSchema,
    nationalCodeSchema,
    optionLabelSchema,
    optionalLongTextSchema,
    optionalOptionValueSchema,
    optionalShortTextSchema,
    optionValueSchema,
    requiredShortTextSchema,
} from "@/utils/validationSchema";

import madrak_1 from "@/assets/hello/madra-1.png"
import madrak_2 from "@/assets/hello/madra-2.png"
import taghvim from "@/assets/hello/dete_icon.png"
import flash from "@/assets/hello/flash.png"
import tic from "@/assets/hello/tic.png"
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { CartItem } from "@/types/cart.type";

import { components } from "react-select";
import { sendVerificationSms } from "@/actions/sendVerificationSms";
import DesktopVideoPlayList from "./DesktopVideoPlayList";
import bebgoroVeidos from "./videos";
import Link from "next/link";

const expireDate = new Date("2026-10-07T00:00:00");
const isExpired = new Date() >= expireDate;

const NoKeyboardInputString = (props: InputProps<StringSelectOption, false>) => (
    <components.Input
        {...props}
        readOnly
        inputMode="none"
    />
);

type IconName =
    | "arrow-left"
    | "book"
    | "briefcase"
    | "calendar"
    | "certificate"
    | "chart"
    | "check"
    | "clock"
    | "close"
    | "rotate3d"
    | "document"
    | "education"
    | "lightbulb"
    | "location"
    | "monitor"
    | "phone"
    | "play"
    | "school"
    | "target"
    | "user"
    | "users";

type SelectOption = {
    value: number;
    label: string;
};
type StringSelectOption = {
    value: string;
    label: string;
};

const teachingGradesSchema = z.array(optionValueSchema(TeachingGrades)).default([]);

const teacherTrainingFormBaseSchema = z.object({
    firstName: requiredShortTextSchema,
    lastName: requiredShortTextSchema,
    nationalCode: nationalCodeSchema,
    birthDay: optionValueSchema(birthDay),
    birthMonth: optionValueSchema(birthMonths),
    birthYear: optionValueSchema(birthYear),
    educationLevel: optionalShortTextSchema,
    major: optionalShortTextSchema,
    province: optionLabelSchema(Ostan),
    city: optionLabelSchema(Cities),
    phoneNumber: mobilePhoneSchema,
    address: optionalLongTextSchema,
    Employmentstatus: optionalOptionValueSchema(Work),
    workplace: optionalShortTextSchema,
    educationDistrict: optionalShortTextSchema,
    personnelCode: z.string().trim().regex(/^\d*$/).max(50).optional().default(""),
    schoolName: optionalShortTextSchema,
    teachingGrades: teachingGradesSchema,
    intelligenceTeachingExperience: optionalOptionValueSchema(TeachingExperience),
});

const teacherTrainingFormSchema = teacherTrainingFormBaseSchema.superRefine(
    (data, context) => {
        const province = Ostan.find((option) => option.label === data.province);

        if (!province) {
            return;
        }

        const cityBelongsToProvince = Cities.some(
            (city) =>
                city.label === data.city && city.provinceId === province.value,
        );

        if (!cityBelongsToProvince) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["city"],
                message: "شهر انتخاب‌شده با استان انتخاب‌شده هم‌خوانی ندارد.",
            });
        }
    },
);

type RegistrationFormData = z.infer<typeof teacherTrainingFormSchema>;

type TeacherTrainingCoursePageProps = {
    posterSrc?: StaticImageData;
    videoSrc?: string;
    onSubmitRegistration?: (
        data: RegistrationFormData,
    ) => void | Promise<void>;
};

type CourseFeature = {
    title: string;
    icon: IconName;
};

const initialFormData: RegistrationFormData = {
    firstName: "",
    lastName: "",

    nationalCode: "",

    birthDay: "",
    birthMonth: "",
    birthYear: "",

    educationLevel: "",
    major: "",

    province: "",
    city: "",

    phoneNumber: "",
    address: "",

    Employmentstatus: "",
    workplace: "",
    educationDistrict: "",
    personnelCode: "",
    schoolName: "",

    teachingGrades: [],
    intelligenceTeachingExperience: "",
};

const teacherTrainingRequestType = "tarbiat-darabi" as const;

const teacherTrainingRegistrationDetailsSchema = z.object({
    firstName: requiredShortTextSchema,
    lastName: requiredShortTextSchema,
    nationalCode: nationalCodeSchema,
    birthDate: birthDateSchema,
    educationLevel: optionalShortTextSchema,
    major: optionalShortTextSchema,
    province: optionLabelSchema(Ostan),
    city: optionLabelSchema(Cities),
    address: optionalLongTextSchema,
    Employmentstatus: optionalOptionValueSchema(Work),
    workplace: optionalShortTextSchema,
    educationDistrict: optionalShortTextSchema,
    personnelCode: z.string().trim().regex(/^\d*$/).max(50).optional().default(""),
    schoolName: optionalShortTextSchema,
    teachingGrades: teachingGradesSchema,
    intelligenceTeachingExperience: optionalOptionValueSchema(TeachingExperience),
    phoneNumberProfile: z.string().trim().max(30).optional().default(""),
    phoneNumberForm: mobilePhoneSchema,
    registerDate: z.string().trim().min(1).max(100),
});

const teacherTrainingRegistrationSchema = createAdlandLandingRequestSchema(
    teacherTrainingRequestType,
    teacherTrainingRegistrationDetailsSchema,
    emptyEmailSchema,
);

const courseFeatures: CourseFeature[] = [
    {
        title: "ارائه جزوه اختصاصی تدریس در کلاس",
        icon: "document",
    },
    {
        title: "۹۰ ساعت آموزش تخصصی",
        icon: "clock",
    },
    {
        title: "۶۰ جلسه آموزشی",
        icon: "calendar",
    },
    {
        title: "برگزاری به‌صورت آنلاین و آفلاین",
        icon: "monitor",
    },
    {
        title: "دو جلسه در هفته",
        icon: "users",
    },
    {
        title: "آموزش در بستر LMS",
        icon: "education",
    },
    {
        title: "دسترسی کامل به فیلم ضبط‌شده تمام جلسات",
        icon: "play",
    },
    {
        title: "تمرین‌های هفتگی همراه با ارزیابی و بازخورد",
        icon: "chart",
    },
    {
        title: "هماهنگی منتور و پشتیبان آموزشی در طول دوره",
        icon: "user",
    },
    {
        title: "آموزش نکات کاربردی و تجربه‌های واقعی تدریس",
        icon: "lightbulb",
    },
    {
        title: "طراحی مسیر آموزشی برای برگزاری کلاس‌های هوش",
        icon: "location",
    },
];

const courseStats = [
    {
        value: "۹۰ ساعت",
        label: "آموزش تخصصی",
        icon: "clock" as IconName,
    },
    {
        value: "۶۰ جلسه",
        label: "دو جلسه در هفته",
        icon: "calendar" as IconName,
    },
    {
        value: "آنلاین و آفلاین",
        label: "در بستر LMS",
        icon: "monitor" as IconName,
    },
    {
        value: "انتقال تجربه",
        label: "ارزشمند و کاربردی",
        icon: "rotate3d" as IconName,
    },
];

const contactNumbers = [
    "۰۹۰۲۳۳۵۹۱۹۸",
    "۰۹۳۰۰۳۶۴۳۹۷",
    "۰۲۱-۴۴۰۸۴۶۲۷",
];

const inputClassName =
    "h-12 w-full rounded-xl border border-slate-200 bg-white px-4 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 hover:border-blue-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-100";

const textareaClassName =
    "min-h-28 w-full resize-y rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm leading-7 text-slate-800 outline-none transition placeholder:text-slate-400 hover:border-blue-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-100";

function Icon({
    name,
    className = "h-6 w-6",
    strokeWidth = 1.9,
}: {
    name: IconName;
    className?: string;
    strokeWidth?: number;
}) {
    const commonProps = {
        className,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth,
        strokeLinecap: "round" as const,
        strokeLinejoin: "round" as const,
        "aria-hidden": true,
    };

    switch (name) {
        case "arrow-left":
            return (
                <svg {...commonProps}>
                    <path d="M19 12H5" />
                    <path d="m12 19-7-7 7-7" />
                </svg>
            );

        case "book":
            return (
                <svg {...commonProps}>
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z" />
                    <path d="M8 6h8" />
                    <path d="M8 10h7" />
                </svg>
            );

        case "briefcase":
            return (
                <svg {...commonProps}>
                    <rect width="20" height="14" x="2" y="7" rx="2" />
                    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    <path d="M2 12h20" />
                    <path d="M10 12v2h4v-2" />
                </svg>
            );

        case "calendar":
            return (
                <svg {...commonProps}>
                    <rect width="18" height="18" x="3" y="4" rx="2" />
                    <path d="M16 2v4" />
                    <path d="M8 2v4" />
                    <path d="M3 10h18" />
                    <path d="M8 14h.01" />
                    <path d="M12 14h.01" />
                    <path d="M16 14h.01" />
                    <path d="M8 18h.01" />
                    <path d="M12 18h.01" />
                </svg>
            );

        case "certificate":
            return (
                <svg {...commonProps}>
                    <circle cx="12" cy="8" r="5" />
                    <path d="m8.5 12-1.3 9 4.8-2.4 4.8 2.4-1.3-9" />
                    <path d="m10.2 8 1.2 1.2L14 6.7" />
                </svg>
            );

        case "chart":
            return (
                <svg {...commonProps}>
                    <path d="M3 3v18h18" />
                    <path d="m7 16 4-5 3 3 5-7" />
                    <path d="M18 7h1v1" />
                </svg>
            );

        case "check":
            return (
                <svg {...commonProps}>
                    <path d="m5 12 4 4L19 6" />
                </svg>
            );

        case "clock":
            return (
                <svg {...commonProps}>
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 7v5l3 2" />
                </svg>
            );

        case "close":
            return (
                <svg {...commonProps}>
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                </svg>
            );

        case "document":
            return (
                <svg {...commonProps}>
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                    <path d="M14 2v6h6" />
                    <path d="M8 13h8" />
                    <path d="M8 17h8" />
                    <path d="M8 9h2" />
                </svg>
            );

        case "education":
            return (
                <svg {...commonProps}>
                    <path d="m2 10 10-5 10 5-10 5Z" />
                    <path d="M6 12.5v4.2c3.5 2.1 8.5 2.1 12 0v-4.2" />
                    <path d="M22 10v6" />
                </svg>
            );

        case "lightbulb":
            return (
                <svg {...commonProps}>
                    <path d="M9 18h6" />
                    <path d="M10 22h4" />
                    <path d="M8.2 14.8A7 7 0 1 1 15.8 14.8C14.7 15.7 14 16.6 14 18h-4c0-1.4-.7-2.3-1.8-3.2Z" />
                    <path d="M12 2V1" />
                    <path d="m4.2 4.2-.7-.7" />
                    <path d="m19.8 4.2.7-.7" />
                    <path d="M2 12H1" />
                    <path d="M23 12h-1" />
                </svg>
            );

        case "location":
            return (
                <svg {...commonProps}>
                    <path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" />
                    <circle cx="12" cy="10" r="2.5" />
                </svg>
            );

        case "monitor":
            return (
                <svg {...commonProps}>
                    <rect width="20" height="14" x="2" y="3" rx="2" />
                    <path d="M8 21h8" />
                    <path d="M12 17v4" />
                    <path d="m10 8 5 3-5 3Z" />
                </svg>
            );

        case "rotate3d":
            return (
                <svg {...commonProps}>
                    <path d="m15.194 13.707 3.814 1.86-1.86 3.814" />
                    <path d="M16.47214 7.52786 A 5 10 0 1 0 13 21.79796" />
                    <path d="M21.79796 11 A 10 5 0 1 0 19 15.57071" />
                </svg>
            );
        case "phone":
            return (
                <svg {...commonProps}>
                    <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L8 10a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.9.6 2.9.7a2 2 0 0 1 1.7 2Z" />
                </svg>
            );

        case "play":
            return (
                <svg {...commonProps}>
                    <circle cx="12" cy="12" r="9" />
                    <path d="m10 8 6 4-6 4Z" />
                </svg>
            );

        case "school":
            return (
                <svg {...commonProps}>
                    <path d="M3 22V9l9-5 9 5v13" />
                    <path d="M2 22h20" />
                    <path d="M7 12h2" />
                    <path d="M15 12h2" />
                    <path d="M7 16h2" />
                    <path d="M15 16h2" />
                    <path d="M10 22v-4h4v4" />
                </svg>
            );

        case "target":
            return (
                <svg {...commonProps}>
                    <circle cx="12" cy="12" r="9" />
                    <circle cx="12" cy="12" r="5" />
                    <circle cx="12" cy="12" r="1" />
                    <path d="m15.5 8.5 5-5" />
                    <path d="M17 3.5h3.5V7" />
                </svg>
            );

        case "user":
            return (
                <svg {...commonProps}>
                    <circle cx="12" cy="8" r="4" />
                    <path d="M4 22a8 8 0 0 1 16 0" />
                </svg>
            );

        case "users":
            return (
                <svg {...commonProps}>
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.9" />
                    <path d="M16 3.1a4 4 0 0 1 0 7.8" />
                </svg>
            );

        default:
            return null;
    }
}

function SuccessModal({
    open,
    onClose,
    title = "ثبت‌نام شما با موفقیت انجام شد!",
}: {
    open: boolean;
    onClose: () => void;
    title?: string;
    description?: string;
}) {
    useEffect(() => {
        if (!open) return;

        const previousOverflow = document.body.style.overflow;
        const previousPosition = document.body.style.position;
        const previousWidth = document.body.style.width;
        const previousTop = document.body.style.top;
        const scrollY = window.scrollY;

        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.overflow = "hidden";

        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === "Escape") onClose();
        };
        window.addEventListener("keydown", handleEscape);

        return () => {
            document.body.style.position = previousPosition;
            document.body.style.width = previousWidth;
            document.body.style.top = previousTop;
            document.body.style.overflow = previousOverflow;
            window.scrollTo(0, scrollY);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-[110] flex items-end justify-center bg-slate-950/60 p-0 backdrop-blur-sm sm:items-center sm:p-5"
            role="presentation"
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="success-modal-title"
                dir="rtl"
                onClick={(event) => event.stopPropagation()}
                className="relative w-full max-w-md overflow-hidden rounded-t-[28px] bg-white p-6 shadow-2xl sm:rounded-[28px] sm:p-8"
            >
                <button
                    type="button"
                    onClick={
                        () => {
                            onClose();
                            window.location.hash = "";
                        }}
                    className="absolute left-4 top-4 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-slate-100 text-slate-500 transition hover:bg-slate-200 focus:outline-none focus:ring-4 focus:ring-slate-200"
                    aria-label="بستن"
                >
                    <Icon name="close" className="h-4 w-4" />
                </button>

                <div className="flex flex-col items-center text-center">
                    <Image src={tic} alt="tic" />
                    <h2
                        id="success-modal-title"
                        className="text-lg font-black text-green-700 sm:text-xl"
                    >
                        {title}
                    </h2>

                    <hr className="border w-full my-4 border-[#E6E7ED]" />

                    <p className="mt-2 max-w-xs text-sm leading-7 text-slate-500 sm:text-[15px]">
                        لینک ورود به کلاس و اطلاعات بیشتر برای شما از طریق <span className="text-[#2D29BB]">پیامک</span> ارسال خواهد شد .
                    </p>

                    <button
                        type="button"
                        onClick={() => {
                            onClose();
                            window.location.hash = "";
                        }}
                        className="mt-7 flex h-12 w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-[#2D29BB] px-8 text-sm text-white shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-violet-600/25 focus:outline-none focus:ring-4 focus:ring-violet-200"
                    >
                        <CircleCheck name="arrow-left" className="h-5 w-5" />
                        متوجه شدم
                    </button>
                </div>
            </div>
        </div >
    );
}

function SectionHeading({
    children,
    description,
}: {
    children: ReactNode;
    description?: string;
}) {
    return (
        <div className="mb-7 flex flex-col items-center text-center">
            <div className="flex w-full items-center justify-center gap-4">
                <div className="hidden h-px flex-1 bg-gradient-to-r from-[#224CDF] to-transparent sm:block" />

                <span className="hidden h-2.5 w-2.5 shrink-0 rounded-full bg-[#224CDF] sm:block" />

                <h2 className="shrink-0 text-xl font-black text-slate-900 sm:text-2xl lg:text-[28px]">
                    {children}
                </h2>

                <span className="hidden h-2.5 w-2.5 shrink-0 rounded-full bg-[#224CDF] sm:block" />

                <div className="hidden h-px flex-1 bg-gradient-to-l from-[#224CDF] to-transparent sm:block" />
            </div>

            {description ? (
                <p className="mt-3 max-w-3xl text-sm leading-7 text-slate-500 sm:text-base">
                    {description}
                </p>
            ) : null}
        </div>
    );
}

function FormField({
    label,
    required,
    children,
    className = "",
}: {
    label: string;
    required?: boolean;
    children: ReactNode;
    className?: string;
}) {
    return (
        <label className={`block min-w-0 ${className}`}>
            <span className="mb-2 block text-sm font-bold text-slate-700">
                {label}
                {required ? (
                    <span className="mr-1 text-rose-500" aria-hidden="true">
                        *
                    </span>
                ) : null}
            </span>

            {children}
        </label>
    );
}

function RegistrationModal({
    open,
    onClose,
}: {
    open: boolean;
    onClose: () => void;
    onSubmitRegistration?: (
        data: RegistrationFormData,
    ) => void | Promise<void>;
}) {
    const [formData, setFormData] =
        useState<RegistrationFormData>(initialFormData);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [selectedProvince, setSelectedProvince] = useState<SelectOption | null>(null);
    const [selectedCity, setSelectedCity] = useState<SelectOption | null>(null);

    const [products, setProducts] = useState<CartItem[]>([]);
    const [hasProduct, setHasProduct] = useState(false);

    const productIds = useMemo(
        () => [
            "e168642e-6718-4fe6-a7d6-a07984d81b2f",
            "1070ef7f-c0fb-4e40-bd69-5aec5e8de2ec",
        ],
        []
    );

    const filteredCities = Cities.filter(
        (city) => city.provinceId === Number(selectedProvince?.value)
    );

    const { addToCart, clearCart } = useCart();


    useEffect(() => {
        if (!open) {
            return;
        }

        const previousOverflow = document.body.style.overflow;
        const previousPosition = document.body.style.position;
        const previousWidth = document.body.style.width;
        const previousTop = document.body.style.top;

        const scrollY = window.scrollY;

        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.overflow = 'hidden';

        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        window.addEventListener("keydown", handleEscape);

        return () => {
            document.body.style.position = previousPosition;
            document.body.style.width = previousWidth;
            document.body.style.top = previousTop;
            document.body.style.overflow = previousOverflow;

            window.scrollTo(0, scrollY);

            window.removeEventListener("keydown", handleEscape);
        };
    }, [open, onClose]);

    const updateField = <Key extends keyof RegistrationFormData>(
        key: Key,
        value: RegistrationFormData[Key],
    ) => {
        setFormData((previous) => ({
            ...previous,
            [key]: value,
        }));
    };

    const { user: profile } = useUser();

    const now = new Date();

    const registerDate = now.toLocaleString("fa-IR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        setIsSubmitting(true);
        setSubmitError("");

        try {
            const parsedForm = teacherTrainingFormSchema.safeParse(formData);

            if (!parsedForm.success) {
                setSubmitError("اطلاعات فرم معتبر نیست.");
                return;
            }

            const validForm = parsedForm.data;
            const birthDate = `${validForm.birthYear}/${validForm.birthMonth}/${validForm.birthDay}`;
            const registrationDetails = {
                firstName: validForm.firstName,
                lastName: validForm.lastName,
                nationalCode: validForm.nationalCode,
                birthDate,
                educationLevel: validForm.educationLevel,
                major: validForm.major,
                province: validForm.province,
                city: validForm.city,
                address: validForm.address,
                Employmentstatus: validForm.Employmentstatus,
                workplace: validForm.workplace,
                educationDistrict: validForm.educationDistrict,
                personnelCode: validForm.personnelCode,
                schoolName: validForm.schoolName,
                teachingGrades: validForm.teachingGrades,
                intelligenceTeachingExperience: validForm.intelligenceTeachingExperience,
                phoneNumberProfile: profile?.phoneNumber || "",
                phoneNumberForm: validForm.phoneNumber,
                registerDate,
            };

            const parsedPayload = teacherTrainingRegistrationSchema.safeParse({
                requestType: teacherTrainingRequestType,
                fullName: `${validForm.firstName} ${validForm.lastName}`.trim(),
                phone: validForm.phoneNumber,
                email: "",
                data: registrationDetails,
            });

            if (!parsedPayload.success) {
                setSubmitError("اطلاعات فرم معتبر نیست.");
                return;
            }

            const result = await submitTeacherTrainingRegistration(parsedPayload.data);

            if (!result.success) {
                setSubmitError(result.message);
                return;
            }

            const cart = await getCartData(productIds);
            setProducts(cart.product);
            toast.success("ثبت‌نام شما با موفقیت انجام شد.");
            localStorage.setItem("teacherTrainingRegistered", "true");
            setIsSubmitted(true);
        } catch (error) {
            console.error('Registration error:', error);
            setSubmitError("خطا در ثبت اطلاعات. لطفاً دوباره تلاش کنید.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // const resetAndClose = () => {
    //     setIsSubmitted(false);
    //     setSubmitError("");
    //     setFormData(initialFormData);
    //     onClose();
    // };

    useEffect(() => {
        if (!open) return;

        const loadData = async () => {
            const registered =
                localStorage.getItem("teacherTrainingRegistered") === "true";

            if (!registered) return;

            setIsSubmitted(true);

            const cart = await getCartData(productIds);
            setProducts(cart.product);
            setHasProduct(true);
        };

        loadData();
    }, [open, productIds]);

    useEffect(() => {
        if (hasProduct) {
            clearCart();
            setHasProduct(false);
        }
    }, [hasProduct, clearCart]);

    if (!open) {
        return null;
    }

    const addProductToCart = (product?: CartItem) => {
        if (!product) return;

        addToCart({
            id: product.id,
            price: product.price,
            discountAmount: product.discountAmount,
            name: product.name,
            description: product.description,
            thumbnailUrl: product.thumbnailUrl,
        });

        toast.success("محصول به سبد خرید اضافه شد.");
        window.location.href = "/basket";
    };

    const pardakhtyekja = products.find(
        (item) => item.id === "e168642e-6718-4fe6-a7d6-a07984d81b2f"
    );
    const pardakhtghesti = products.find(
        (item) => item.id === "1070ef7f-c0fb-4e40-bd69-5aec5e8de2ec"
    );

    return (
        <div
            className="fixed inset-0 z-[100] flex items-end justify-center bg-slate-950/60 p-0 backdrop-blur-sm sm:items-center sm:p-5"
            role="presentation"
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="registration-modal-title"
                className="relative flex max-h-[96dvh] w-full max-w-2xl flex-col overflow-hidden rounded-t-[28px] bg-white shadow-2xl sm:max-h-[92dvh] sm:rounded-[28px]"
                dir="rtl"
            >
                <div className="relative shrink-0 overflow-hidden border-b border-slate-100 px-5 py-5 text-white sm:px-8 sm:py-6">
                    <div className="pointer-events-none absolute -left-16 -top-20 h-56 w-56 rounded-full border-[36px] border-white/10" />
                    <div className="pointer-events-none absolute bottom-0 right-1/3 h-24 w-24 translate-y-1/2 rounded-full bg-white/10 blur-xl" />

                    <div className="relative flex items-center justify-between gap-5">
                        <div className="min-w-0">
                            {isSubmitted ? (
                                <>
                                    <h2 id="registration-modal-title" className="text-black sm:text-2xl">
                                        تکمیل فرآیند خرید
                                    </h2>
                                </>
                            ) : (
                                <h2 id="registration-modal-title" className="text-black sm:text-2xl">
                                    فرم ثبت‌نام دوره تربیت معلم هوش
                                </h2>
                            )}
                        </div>

                        <button
                            type="button"
                            onClick={onClose}
                            className="flex cursor-pointer h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/15 text-black transition hover:bg-white/60 focus:outline-none focus:ring-4 focus:ring-white/20"
                            aria-label="بستن فرم ثبت‌نام"
                        >
                            <Icon name="close" className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
                    {isSubmitted ? (
                        <div className="flex min-h-[450px] flex-col items-center justify-center text-center">
                            <div className="mb-4 mt-10 flex h-24 w-24 items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
                                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100">
                                    <Icon
                                        name="check"
                                        className="h-9 w-9"
                                        strokeWidth={2.5}
                                    />
                                </div>
                            </div>
                            <p className="text-emerald-600 sm:text-lg">ثبت نام شما با موفقیت انجام شد !</p>
                            <p className="text-gray-700 sm:text-lg px-10">برای تکمیل فرآیند ، روش پرداخت مورد نظر خود را انتخاب کنید.</p>
                            <div className="w-full sm:px-10 px-5">
                                <div className="flex sm:flex-row flex-col gap-10 mt-8 mb-10 w-full">
                                    <div className="shadow-xl/20 rounded-2xl w-full">
                                        <div className="p-5 space-y-3">
                                            <div className="flex sm:flex-row flex-col lg:flex-col">
                                                <div className="flex sm:justify-center justify-between mb-1">
                                                    <div className="flex sm:flex-col flex-row gap-3 items-center justify-center">
                                                        <div className="bg-green-200/40 mx-auto rounded-full sm:w-20 w-10 h-10 sm:h-20 items-center justify-center flex">
                                                            <Wallet className="text-green-900 sm:w-10 sm:h-10 w-6 h-6" />
                                                        </div>
                                                        <div>
                                                            <h3 className="sm:text-lg font-bold">
                                                                پرداخت کامل
                                                            </h3>
                                                        </div>
                                                    </div>
                                                    <div className="sm:hidden flex items-center">
                                                        <div className="p-2 bg-green-200/35 border border-green-700 rounded-2xl flex gap-2 justify-between px-5">
                                                            <p>{pardakhtyekja?.price}</p>
                                                            <p>تومان</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="border-gray-300 rounded-2xl sm:w-full w-48 hidden lg:block" />
                                                <div className="flex sm:flex-col sm:gap-0 gap-4 mt-3">
                                                    <div className="gap-2 mb-2 sm:justify-center hidden lg:flex sm:text-md text-sm sm:text-black text-green-900 items-center">
                                                        <Tags className="text-green-900" />
                                                        <p>قیمت محصول</p>
                                                    </div>
                                                    <div className="hidden lg:flex p-2 bg-green-200/35 border border-green-700 rounded-2xl mx-auto w-auto gap-2 justify-between sm:px-10 px-5">
                                                        <p>{pardakhtyekja?.price}</p>
                                                        <p>تومان</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => addProductToCart(pardakhtyekja)}
                                            className="mb-3 h-12 w-[calc(100%-2.5rem)] lg:w-auto flex gap-2 items-center justify-center mx-auto cursor-pointer rounded-xl bg-green-700/75 px-8 text-sm font-black text-white transition focus:outline-none focus:ring-4 focus:ring-violet-200">
                                            رفتن به سبد خرید
                                            <MoveLeft />
                                        </button>
                                    </div>


                                    <div className="shadow-xl/20 rounded-2xl w-full">
                                        <div className="p-5 space-y-3">
                                            <div className="flex sm:flex-row flex-col lg:flex-col">
                                                <div className="flex sm:justify-center justify-between mb-1">
                                                    <div className="flex sm:flex-col flex-row gap-3 items-center justify-center">
                                                        <div className="bg-blue-200/40 mx-auto rounded-full sm:w-20 w-10 h-10 sm:h-20 items-center justify-center flex">
                                                            <CalendarRange className="text-blue-900 sm:w-10 sm:h-10 w-6 h-6" />
                                                        </div>
                                                        <div>
                                                            <h3 className="sm:text-lg font-bold">
                                                                پرداخت اقساطی
                                                            </h3>
                                                            <p className="lg:hidden block text-sm bg-blue-400/35 p-1 rounded-2xl border border-blue-800 text-blue-600 mt-0.5">قسط اول</p>
                                                        </div>
                                                    </div>
                                                    <div className="sm:hidden flex items-center">
                                                        <div className="p-2 bg-blue-200/85 border border-blue-700 rounded-2xl flex gap-2 justify-between px-5">
                                                            <p>{pardakhtghesti?.price}</p>
                                                            <p>تومان</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="border-gray-300 rounded-2xl sm:w-full w-48 hidden lg:block" />
                                                <div className="flex sm:flex-col sm:gap-0 gap-4 mt-3">
                                                    <div className="gap-2 mb-2 sm:justify-center hidden lg:flex sm:text-md text-sm sm:text-black text-blue-900 items-center">
                                                        <Tags className="text-blue-900" />
                                                        <p>قسط اول</p>
                                                    </div>
                                                    <div className="hidden lg:flex p-2 bg-blue-200/35 border border-blue-700 rounded-2xl mx-auto w-auto gap-2 justify-between sm:px-10 px-5">
                                                        <p>{pardakhtghesti?.price}</p>
                                                        <p>تومان</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => addProductToCart(pardakhtghesti)}
                                            className="mb-3 h-12 w-[calc(100%-2.5rem)] lg:w-auto flex gap-2 items-center justify-center mx-auto cursor-pointer rounded-xl bg-blue-700/75 px-8 text-sm font-black text-white transition focus:outline-none focus:ring-4 focus:ring-violet-200">
                                            رفتن به سبد خرید
                                            <MoveLeft />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="p-5 sm:p-8">
                            <section>
                                <div className="mb-5 flex items-center gap-3">
                                    <div>
                                        <h3 className="font-black text-slate-900">
                                            اطلاعات فردی
                                        </h3>
                                    </div>
                                </div>

                                <div className="grid sm:grid-cols-2 grid-cols-1 gap-7">
                                    <FormField label="نام" required>
                                        <input
                                            type="text"
                                            autoComplete="given-name"
                                            required
                                            value={formData.firstName}
                                            onChange={(event) =>
                                                updateField("firstName", event.target.value)
                                            }
                                            className={inputClassName}
                                            placeholder="نام خود را وارد کنید"
                                        />
                                    </FormField>

                                    <FormField label="نام خانوادگی" required>
                                        <input
                                            type="text"
                                            autoComplete="family-name"
                                            required
                                            value={formData.lastName}
                                            onChange={(event) =>
                                                updateField("lastName", event.target.value)
                                            }
                                            className={inputClassName}
                                            placeholder="نام خانوادگی خود را وارد کنید"
                                        />
                                    </FormField>

                                    <FormField label="شماره موبایل" required className="relative">
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            autoComplete="off"
                                            maxLength={11}
                                            minLength={11}
                                            value={formData.phoneNumber}
                                            required
                                            onChange={(event) =>
                                                updateField(
                                                    "phoneNumber",
                                                    event.target.value.replace(/\D/g, "").slice(0, 11),
                                                )
                                            }
                                            className={inputClassName}
                                            placeholder="09121486022"
                                        />
                                        {formData.phoneNumber.length > 0 && formData.phoneNumber.length < 11 && (
                                            <p className="text-red-500 text-[12px] mt-1 absolute">
                                                شماره موبایل باید 11 رقم باشد
                                            </p>
                                        )}
                                    </FormField>
                                    <FormField label="کد ملی" required className="relative min-h-[80px]">
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            autoComplete="off"
                                            maxLength={10}
                                            required
                                            value={formData.nationalCode}
                                            onChange={(event) =>
                                                updateField(
                                                    "nationalCode",
                                                    event.target.value.replace(/\D/g, "").slice(0, 10),
                                                )
                                            }
                                            className={`${inputClassName} text-right`}
                                            placeholder="مثلاً ۰۰۱۲۳۴۵۶۷۸"
                                        />
                                        {formData.nationalCode.length > 0 && formData.nationalCode.length < 10 && (
                                            <p className="text-red-500 text-[12px] mt-1 absolute">
                                                کدملی باید 10 رقم باشد
                                            </p>
                                        )}
                                    </FormField>

                                    <div>
                                        <span className="mb-2 block text-sm font-bold text-slate-700">
                                            تاریخ تولد
                                            <span className="mr-1 text-rose-500" aria-hidden="true">
                                                *
                                            </span>
                                        </span>
                                        <div className="grid grid-cols-3 w-full gap-1">
                                            <Select
                                                unstyled
                                                required
                                                options={birthDay}
                                                placeholder="روز"
                                                components={{ Input: NoKeyboardInputString }}
                                                onChange={(option) => {
                                                    updateField("birthDay", String(option?.value ?? ""));
                                                }}
                                                className="w-full"
                                                classNames={{
                                                    container: () => "relative w-full",
                                                    control: (state) =>
                                                        `rounded-[10px] border cursor-pointer px-1 sm:text-[14px] w-full text-center py-3 bg-white ${state.isFocused ? "border-blue-500 ring-1 ring-blue-500" : "border-gray-300"
                                                        }`,
                                                    valueContainer: () => "flex items-center justify-center gap-1 px-1 overflow-hidden",
                                                    input: () => "text-gray-900",
                                                    singleValue: () => "text-gray-900 truncate",
                                                    placeholder: () => "text-gray-400 truncate",
                                                    indicatorsContainer: () => "flex items-center gap-1",
                                                    menu: () => "absolute z-20 mt-1 w-full rounded-2xl text-center text-[14px] border border-gray-200 bg-white shadow-lg overflow-hidden",
                                                    menuList: () => "py-1 max-h-60 overflow-y-auto",
                                                    option: (state) =>
                                                        `px-3 text-center py-2 cursor-pointer ${state.isFocused ? "bg-blue-50" : "bg-white"}`,
                                                }}
                                            />
                                            <Select
                                                unstyled
                                                required
                                                components={{ Input: NoKeyboardInputString }}
                                                onChange={(option) => {
                                                    updateField(
                                                        "birthMonth",
                                                        option?.value || ""
                                                    );
                                                }}
                                                // isSearchable={false}
                                                options={birthMonths}
                                                placeholder="ماه"
                                                className="w-full"
                                                classNames={{
                                                    container: () => "relative w-full",
                                                    control: (state) =>
                                                        `rounded-[10px] border cursor-pointer px-1 sm:text-[14px] w-full text-center py-3 bg-white ${state.isFocused ? "border-blue-500 ring-1 ring-blue-500" : "border-gray-300"
                                                        }`,
                                                    valueContainer: () => "flex items-center justify-center gap-1 px-1 overflow-hidden",
                                                    input: () => "text-gray-900",
                                                    singleValue: () => "text-gray-900 truncate mx-auto",
                                                    placeholder: () => "text-gray-400 truncate",
                                                    indicatorsContainer: () => "flex items-center gap-1",
                                                    menu: () => "absolute z-20 mt-1 w-full rounded-2xl text-center text-[14px] border border-gray-200 bg-white shadow-lg overflow-hidden",
                                                    menuList: () => "py-1 max-h-60 overflow-y-auto",
                                                    option: (state) =>
                                                        `px-3 text-center py-2 cursor-pointer ${state.isFocused ? "bg-blue-50" : "bg-white"}`,
                                                }}
                                            />
                                            <Select
                                                unstyled
                                                required
                                                components={{ Input: NoKeyboardInputString }}
                                                onChange={(option) => {
                                                    updateField(
                                                        "birthYear",
                                                        option?.value || ""
                                                    );
                                                }}
                                                options={birthYear}
                                                placeholder="سال"
                                                className="w-full"
                                                classNames={{
                                                    container: () => "relative w-full",
                                                    control: (state) =>
                                                        `rounded-[10px] border cursor-pointer px-1 sm:text-[14px] w-full text-center py-3 bg-white ${state.isFocused ? "border-blue-500 ring-1 ring-blue-500" : "border-gray-300"
                                                        }`,
                                                    valueContainer: () => "flex items-center justify-center gap-1 px-1 overflow-hidden",
                                                    input: () => "text-gray-900",
                                                    singleValue: () => "text-gray-900 truncate",
                                                    placeholder: () => "text-gray-400 truncate",
                                                    indicatorsContainer: () => "flex items-center gap-1",
                                                    menu: () => "absolute z-20 mt-1 w-full rounded-2xl text-center text-[14px] border border-gray-200 bg-white shadow-lg overflow-hidden",
                                                    menuList: () => "py-1 max-h-60 overflow-y-auto",
                                                    option: (state) =>
                                                        `px-3 text-center py-2 cursor-pointer ${state.isFocused ? "bg-blue-50" : "bg-white"}`,
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <FormField label="استان" required>
                                        <Select
                                            unstyled
                                            options={Ostan}
                                            value={selectedProvince}
                                            onChange={(option) => {
                                                setSelectedProvince(option);

                                                updateField(
                                                    "province",
                                                    option?.label || ""
                                                );

                                                setSelectedCity(null);

                                                updateField(
                                                    "city",
                                                    ""
                                                );
                                            }}
                                            placeholder="انتخاب کنید"
                                            classNames={{
                                                control: (state) =>
                                                    `rounded-[10px] border cursor-pointer text-[14px] px-3 py-3 bg-white ${state.isFocused
                                                        ? "border-blue-500 ring-1 ring-blue-500"
                                                        : "border-gray-300"
                                                    }`,
                                                menu: () =>
                                                    "rounded-2xl text-[14px] border border-gray-200 bg-white shadow-lg mt-1 overflow-hidden",
                                                menuList: () => "py-1",
                                                option: (state) =>
                                                    `px-3 py-2 cursor-pointer ${state.isFocused ? "bg-blue-50" : "bg-white"
                                                    }`,
                                                placeholder: () => "text-gray-400",
                                                singleValue: () => "text-gray-900",
                                            }}
                                        />
                                    </FormField>


                                    <FormField label="شهر" required>
                                        <Select
                                            unstyled
                                            options={filteredCities}
                                            value={selectedCity}
                                            onChange={(option) => {

                                                setSelectedCity(option);

                                                updateField(
                                                    "city",
                                                    option?.label || ""
                                                );
                                            }}
                                            isDisabled={!selectedProvince}
                                            placeholder={
                                                selectedProvince
                                                    ? "انتخاب کنید"
                                                    : "ابتدا استان را انتخاب کنید"
                                            }
                                            classNames={{
                                                control: (state) =>
                                                    `rounded-[10px] border cursor-pointer text-[14px] px-3 py-3 bg-white ${state.isFocused
                                                        ? "border-blue-500 ring-1 ring-blue-500"
                                                        : "border-gray-300"
                                                    } ${selectedProvince === null || selectedProvince === undefined
                                                        ? "cursor-not-allowed opacity-60"
                                                        : "cursor-pointer"
                                                    }`,
                                                menu: () =>
                                                    "rounded-2xl text-[14px] border border-gray-200 bg-white shadow-lg mt-1 overflow-hidden",
                                                menuList: () => "py-1",
                                                option: (state) =>
                                                    `px-3 py-2 cursor-pointer ${state.isFocused ? "bg-blue-50" : "bg-white"
                                                    }`,
                                                placeholder: () => "text-gray-400",
                                                singleValue: () => "text-gray-900",
                                            }}
                                        />
                                    </FormField>

                                    <FormField label="آخرین مدرک تحصیلی">
                                        <div>
                                            <input
                                                type="text"
                                                value={formData.educationLevel}
                                                onChange={(event) =>
                                                    updateField("educationLevel", event.target.value)
                                                }
                                                className={inputClassName}
                                                placeholder="برای مثال لیسانس"
                                            />
                                        </div>
                                    </FormField>

                                    <FormField label="رشته تحصیلی">
                                        <input
                                            type="text"
                                            value={formData.major}
                                            onChange={(event) =>
                                                updateField("major", event.target.value)
                                            }
                                            className={inputClassName}
                                            placeholder="عنوان رشته تحصیلی"
                                        />
                                    </FormField>

                                    <FormField
                                        label="آدرس"
                                        className="md:col-span-2 lg:col-span-2"
                                    >
                                        <textarea
                                            autoComplete="street-address"
                                            value={formData.address}
                                            onChange={(event) =>
                                                updateField("address", event.target.value)
                                            }
                                            className={textareaClassName}
                                            placeholder="آدرس کامل محل سکونت را وارد کنید"
                                        />
                                    </FormField>
                                </div>
                            </section>


                            <FormField label="" className="mt-5 w-48">
                                <div className="mb-3 flex items-center gap-3 mt-5">
                                    <div>
                                        <h3 className="font-black text-slate-900">
                                            وضعیت اشتغال
                                        </h3>
                                    </div>
                                </div>
                                <Select
                                    unstyled
                                    onChange={(option) => {
                                        updateField(
                                            "Employmentstatus",
                                            option?.value || ""
                                        );
                                    }}
                                    isSearchable={false}
                                    options={Work}
                                    menuPlacement="top"
                                    placeholder="انتخاب کنید"
                                    classNames={{
                                        control: (state) =>
                                            `rounded-[10px] border cursor-pointer px-3 text-[14px] text-right py-3 bg-white ${state.isFocused ? "border-blue-500 ring-1 ring-blue-500" : "border-gray-300"
                                            }`,
                                        menu: () => "rounded-2xl text-right text-[14px] border border-gray-200 bg-white shadow-lg mt-1 overflow-hidden",
                                        menuList: () => "py-1",
                                        option: (state) =>
                                            `px-3 py-2 cursor-pointer ${state.isFocused ? "bg-blue-50" : "bg-white"
                                            }`,
                                        placeholder: () => "text-gray-400",
                                        singleValue: () => "text-gray-900",
                                    }}
                                />
                            </FormField>

                            {formData.Employmentstatus &&
                                formData.Employmentstatus !== "دانشجو" && formData.Employmentstatus !== "شاغل نیستم" && (
                                    <section>
                                        <div className="mb-5 flex items-center gap-3 mt-5">
                                            <div>
                                                <h3 className="font-black text-slate-900">
                                                    اطلاعات شغلی
                                                </h3>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2">
                                            <FormField label="محل خدمت">
                                                <input
                                                    type="text"
                                                    value={formData.workplace}
                                                    onChange={(event) =>
                                                        updateField("workplace", event.target.value)
                                                    }
                                                    className={inputClassName}
                                                    placeholder="نام سازمان یا محل خدمت"
                                                />
                                            </FormField>

                                            <FormField label="منطقه آموزش و پرورش">
                                                <input
                                                    type="text"
                                                    value={formData.educationDistrict}
                                                    onChange={(event) =>
                                                        updateField(
                                                            "educationDistrict",
                                                            event.target.value,
                                                        )
                                                    }
                                                    className={inputClassName}
                                                    placeholder="مثلاً منطقه ۲ "
                                                />
                                            </FormField>

                                            <FormField label="کد پرسنلی">
                                                <input
                                                    type="text"
                                                    inputMode="numeric"
                                                    value={formData.personnelCode}
                                                    onChange={(event) =>
                                                        updateField(
                                                            "personnelCode",
                                                            event.target.value.replace(/\D/g, ""),
                                                        )
                                                    }
                                                    className={inputClassName}
                                                    placeholder="کد پرسنلی"
                                                />
                                            </FormField>

                                            <FormField label="نام مدرسه محل تدریس">
                                                <input
                                                    type="text"
                                                    value={formData.schoolName}
                                                    onChange={(event) =>
                                                        updateField("schoolName", event.target.value)
                                                    }
                                                    className={inputClassName}
                                                    placeholder="نام مدرسه"
                                                />
                                            </FormField>
                                        </div>

                                        <FormField label="پایه‌های تدریس" className="mt-5">
                                            <Select
                                                unstyled
                                                menuPlacement="top"
                                                isMulti
                                                placeholder="انتخاب کنید"
                                                options={TeachingGrades}
                                                isSearchable={false}
                                                value={TeachingGrades.filter(
                                                    item =>
                                                        formData.teachingGrades.includes(item.value)
                                                )}
                                                onChange={(options) => {
                                                    updateField(
                                                        "teachingGrades",
                                                        options.map(item => item.value)
                                                    )
                                                }}
                                                styles={{
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        flexWrap: "wrap",
                                                        rowGap: "4px",
                                                        overflow: "visible"
                                                    }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: "#3778E2",
                                                        borderRadius: 5,
                                                        margin: "2px",
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        color: "#fff",
                                                        fontWeight: 500,
                                                        padding: "6px 8px",
                                                        whiteSpace: "nowrap",
                                                    }),
                                                    multiValueRemove: (base) => ({
                                                        ...base,
                                                        color: "#fff",
                                                        padding: "6px",
                                                        margin: "5px",
                                                        borderRadius: "100%",
                                                        ":hover": {
                                                            backgroundColor: "#e5383b",
                                                            color: "#fff",
                                                            borderRadius: "100%",
                                                            cursor: "pointer"
                                                        },
                                                    }),
                                                }}
                                                classNames={{
                                                    control: (state) =>
                                                        `rounded-[10px] border cursor-pointer !min-h-16 text-[14px] px-3 py-3 bg-white ${state.isFocused ? "border-blue-500 ring-1 ring-blue-500" : "border-gray-300"
                                                        }`,
                                                    menu: () => "rounded-2xl text-[14px] border border-gray-200 bg-white shadow-lg mt-1 overflow-hidden",
                                                    menuList: () => "py-1",
                                                    option: (state) =>
                                                        `px-3 py-2 cursor-pointer ${state.isFocused ? "bg-blue-50" : "bg-white"
                                                        }`,
                                                    placeholder: () => "text-gray-400",
                                                    singleValue: () => "text-gray-900",
                                                }}
                                            />
                                        </FormField>
                                        <br />
                                        <FormField label="سابقه تدریس هوش">
                                            <Select
                                                unstyled
                                                options={TeachingExperience}
                                                onChange={(option) => {
                                                    updateField(
                                                        "intelligenceTeachingExperience",
                                                        option?.value || ""
                                                    );
                                                }}
                                                isSearchable={false}
                                                placeholder="انتخاب کنید"
                                                menuPlacement="top"
                                                classNames={{
                                                    control: (state) =>
                                                        `rounded-[10px] border cursor-pointer text-[14px] px-3 py-3 bg-white ${state.isFocused ? "border-blue-500 ring-1 ring-blue-500" : "border-gray-300"
                                                        }`,
                                                    menu: () => "rounded-2xl text-[14px] border border-gray-200 bg-white shadow-lg mt-1 overflow-hidden",
                                                    menuList: () => "py-1",
                                                    option: (state) =>
                                                        `px-3 py-2 cursor-pointer ${state.isFocused ? "bg-blue-50" : "bg-white"
                                                        }`,
                                                    placeholder: () => "text-gray-400",
                                                    singleValue: () => "text-gray-900",
                                                }}
                                            />
                                        </FormField>

                                    </section>
                                )}

                            {submitError ? (
                                <div
                                    role="alert"
                                    className="mt-6 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-bold text-rose-700"
                                >
                                    {submitError}
                                </div>
                            ) : null}

                            <div className="sticky bottom-0 sm:pb-2 z-10 mt-8 border-t border-slate-100 bg-white/95 px-5 pb-1 pt-4 backdrop-blur sm:-mx-8 sm:px-8">
                                <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
                                    <button
                                        type="button"
                                        onClick={onClose}
                                        disabled={isSubmitting}
                                        className="h-12 cursor-pointer rounded-xl border border-slate-200 bg-white px-7 text-sm font-black text-slate-600 transition hover:border-slate-300 hover:bg-slate-50 focus:outline-none focus:ring-4 focus:ring-slate-100 disabled:cursor-not-allowed disabled:opacity-50"
                                    >
                                        انصراف
                                    </button>

                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="flex cursor-pointer h-12 items-center justify-center gap-2 rounded-xl bg-[#224CDF] px-8 text-sm font-black text-white shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-violet-600/25 focus:outline-none focus:ring-4 focus:ring-violet-200 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0"
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white" />
                                                در حال ثبت...
                                            </>
                                        ) : (
                                            <>
                                                <p className="flex gap-2">
                                                    ثبت نام
                                                    <Icon name="arrow-left" className="h-5 w-5" />
                                                </p>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    )}
                </div>
            </div >
        </div >
    );
}

function FeatureCard({ feature }: { feature: CourseFeature }) {
    return (
        <div className="group flex min-h-[92px] items-center gap-4 rounded-2xl border border-slate-200/90 bg-white px-5 py-4 shadow-[0_8px_30px_rgba(15,23,42,0.035)] transition duration-300 hover:-translate-y-1 hover:border-violet-200 hover:shadow-[0_16px_40px_rgba(109,40,217,0.09)]">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100 text-[#224CDF] transition duration-300 group-hover:scale-105 group-hover:bg-violet-600 group-hover:text-indigo-600">
                <Icon name={feature.icon} className="h-6 w-6" />
            </div>
            <p className="min-w-0 text-sm font-bold leading-7 text-slate-700 sm:text-[15px]">
                {feature.title}
            </p>
        </div>
    );
}

export default function LearnhooshContext({
    posterSrc = posterfilm,
    videoSrc = "https://www.aparat.com/video/video/embed/videohash/xlv4o93/vt/frame",
    onSubmitRegistration,
}: TeacherTrainingCoursePageProps) {
    const [registrationOpen, setRegistrationOpen] = useState(false);
    const [registrationOpenConference, setRegistrationOpenConference] = useState(false);
    const { isLoggedIn, user: profile } = useUser();
    const templateId = Number(process.env.SMS_IR_TEMP_ID);

    const handleOpenConferenceModal = useCallback(async () => {
        const SMS_KEY = `sms-sent_${profile?.phoneNumber}`;

        if (localStorage.getItem(SMS_KEY) === 'true') {
            setRegistrationOpenConference(true);
            return;
        }

        // if (!profile?.phoneNumber) {
        //     console.error("شماره موبایل کاربر موجود نیست");
        //     return;
        // }
        // console.log("dsgljdfsg" + profile?.phoneNumber)

        // if (!templateId) {
        //     console.error("SMS_IR_TEMP_ID تنظیم نشده است");
        //     return;
        // }

        try {

            const adlandResult = await submitTeacherTrainingRegistration({
                requestType: "وبینار تربیت‌معلم",
                fullName: `${profile?.firstName ?? ""} ${profile?.lastName ?? ""}`.trim() || "مهمان",
                phone: profile?.phoneNumber,
                email: "",
                data: {}
            })
            console.log(adlandResult)

            if (!adlandResult.success) {
                console.log("ناموفق")
            }

            const result = await sendVerificationSms({
                mobile: profile?.phoneNumber ?? "",
                templateId: templateId,
                parameters: [
                    { name: "LINK", value: "wh" },
                    { name: "NAME", value: "کاربر عزیز: " + profile?.phoneNumber + " " },
                ]
            });
            console.log(result)
            if (!result.success) {
                alert(result.message);
                return;
            }

            localStorage.setItem(SMS_KEY, 'true');
            setRegistrationOpenConference(true);
        } catch (error) {
            console.error("Send verification SMS error:", error);
            alert("خطا در ارسال کد تأیید");
        }
    }, [profile?.phoneNumber]);


    useEffect(() => {
        if (isLoggedIn && window.location.hash === "#modal") {
            setRegistrationOpen(true);
        }
    }, [isLoggedIn]);

    const hasOpenedConference = useRef(false);

    useEffect(() => {
        if (isLoggedIn && window.location.hash === "#conference-modal" && !hasOpenedConference.current) {
            if (profile?.phoneNumber) {
                hasOpenedConference.current = true;
                handleOpenConferenceModal();
            } else {
                const timer = setTimeout(() => {
                    if (profile?.phoneNumber && !hasOpenedConference.current) {
                        hasOpenedConference.current = true;
                        handleOpenConferenceModal();
                    }
                }, 500);
                return () => clearTimeout(timer);
            }
        }
    }, [isLoggedIn, profile, handleOpenConferenceModal]);

    // useEffect(() => {
    //     if (window.location.hash !== "#modal") return;

    //     const timer = setTimeout(() => {
    //         if (isLoggedIn) {
    //             setRegistrationOpen(true);
    //         }
    //     }, 1000);

    //     return () => clearTimeout(timer);
    // }, [isLoggedIn]);

    const RegistrationButton = useCallback(() => {
        if (isLoggedIn) {
            return (
                <div className="flex sm:flex-row flex-col gap-2">
                    {!isExpired && (
                        <button
                            type="button"
                            onClick={() => {
                                handleOpenConferenceModal()
                            }}
                            className="group cursor-pointer flex min-h-16 w-full items-center justify-between rounded-2xl border border-white/20 bg-gradient-to-l from-[#157212] via-green-600 to-green-800 px-3 py-2 text-white transition duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-violet-200 sm:min-h-[76px] sm:px-4"
                        >
                            <span className="w-12 sm:w-16" />
                            <span className="text-2xl font-black sm:text-3xl">
                                ثبت‌نام وبینار رایگان
                            </span>
                            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#127728] shadow-lg transition duration-300 group-hover:-translate-x-1 sm:h-13 sm:w-13">
                                <Icon
                                    name="arrow-left"
                                    className="h-6 w-6 sm:h-7 sm:w-7"
                                    strokeWidth={2.4}
                                />
                            </span>
                        </button>
                    )}
                    <Link
                        onClick={e => e.stopPropagation()}
                        href={"/productDetails/c9ef292d-ae29-4f10-a169-a5163c112440"}
                        className="group cursor-pointer flex min-h-[64px] w-full items-center justify-between rounded-2xl border border-white/20 bg-gradient-to-l from-[#df2222] via-[#fd3f3f] to-[#ff3838] px-3 py-2 text-white transition duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-violet-200 sm:min-h-[76px] sm:px-4"
                    >
                        <span className="w-12 sm:w-16" />
                        <span className="text-2xl font-black sm:text-3xl">
                            مشاهده رایگان سه قسمت اول
                        </span>
                        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#df2222] shadow-lg transition duration-300 group-hover:-translate-x-1 sm:h-13 sm:w-13">
                            <Icon
                                name="arrow-left"
                                className="h-6 w-6 sm:h-7 sm:w-7"
                                strokeWidth={2.4}
                            />
                        </span>
                    </Link>
                    <button
                        type="button"
                        onClick={() => {
                            setRegistrationOpen(true)
                        }}
                        className="group cursor-pointer flex min-h-[64px] w-full items-center justify-between rounded-2xl border border-white/20 bg-gradient-to-l from-[#224CDF] via-blue-600 to-blue-800 px-3 py-2 text-white transition duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-violet-200 sm:min-h-[76px] sm:px-4"
                    >
                        <span className="w-12 sm:w-16" />
                        <span className="text-2xl font-black sm:text-3xl">
                            ثبت‌نام در دوره
                        </span>
                        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#224CDF] shadow-lg transition duration-300 group-hover:-translate-x-1 sm:h-13 sm:w-13">
                            <Icon
                                name="arrow-left"
                                className="h-6 w-6 sm:h-7 sm:w-7"
                                strokeWidth={2.4}
                            />
                        </span>
                    </button>
                </div>
            );
        }
        return (
            <AuthStepController
                id="teacher-training-course"
                triggerButton={
                    <div className="flex sm:flex-row flex-col gap-2">
                        {!isExpired && (
                            <button
                                type="button"
                                onClick={() => window.location.hash = "conference-modal"}
                                className="group cursor-pointer flex min-h-16 w-full items-center justify-between rounded-2xl border border-white/20 bg-gradient-to-l from-[#157212] via-green-600 to-green-800 px-3 py-2 text-white transition duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-violet-200 sm:min-h-[76px] sm:px-4"
                            >
                                <span className="w-12 sm:w-16" />
                                <span className="text-2xl font-black sm:text-3xl">
                                    ثبت‌نام وبینار رایگان
                                </span>
                                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#127728] shadow-lg transition duration-300 group-hover:-translate-x-1 sm:h-13 sm:w-13">
                                    <Icon
                                        name="arrow-left"
                                        className="h-6 w-6 sm:h-7 sm:w-7"
                                        strokeWidth={2.4}
                                    />
                                </span>
                            </button>
                        )}
                        <Link
                            onClick={e => e.stopPropagation()}
                            href={"/productDetails/c9ef292d-ae29-4f10-a169-a5163c112440"}
                            className="group cursor-pointer flex min-h-[64px] w-full items-center justify-between rounded-2xl border border-white/20 bg-gradient-to-l from-[#df2222] via-[#fd3f3f] to-[#ff3838] px-3 py-2 text-white transition duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-violet-200 sm:min-h-[76px] sm:px-4"
                        >
                            <span className="w-12 sm:w-16" />
                            <span className="text-2xl font-black sm:text-3xl">
                                مشاهده رایگان سه قسمت اول
                            </span>
                            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#df2222] shadow-lg transition duration-300 group-hover:-translate-x-1 sm:h-13 sm:w-13">
                                <Icon
                                    name="arrow-left"
                                    className="h-6 w-6 sm:h-7 sm:w-7"
                                    strokeWidth={2.4}
                                />
                            </span>
                        </Link>
                        <button
                            type="button"
                            onClick={() => window.location.hash = "modal"}
                            className="group cursor-pointer flex min-h-[64px] w-full items-center justify-between rounded-2xl border border-white/20 bg-gradient-to-l from-[#224CDF] via-blue-600 to-blue-800 px-3 py-2 text-white transition duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-violet-200 sm:min-h-[76px] sm:px-4"
                        >
                            <span className="w-12 sm:w-16" />
                            <span className="text-2xl font-black sm:text-3xl">
                                ثبت‌نام در دوره
                            </span>
                            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#224CDF] shadow-lg transition duration-300 group-hover:-translate-x-1 sm:h-13 sm:w-13">
                                <Icon
                                    name="arrow-left"
                                    className="h-6 w-6 sm:h-7 sm:w-7"
                                    strokeWidth={2.4}
                                />
                            </span>
                        </button>
                    </div>
                }
            />
        );
    }, [isLoggedIn, handleOpenConferenceModal]);

    return (
        <>
            <main
                dir="rtl"
                className="relative isolate overflow-x-clip bg-white text-slate-900 [overflow-wrap:anywhere]">
                <div
                    className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[850px] opacity-75"
                    style={{
                        background:
                            "radial-gradient(circle at 83% 8%, rgba(124,58,237,0.10), transparent 26%), radial-gradient(circle at 14% 25%, rgba(14,165,233,0.08), transparent 24%), linear-gradient(to bottom, #ffffff, #ffffff)",
                    }}
                />

                <div className="mx-auto w-full max-w-360 px-0 pb-10 pt-6 sm:px-6 sm:pt-8 lg:px-8 lg:pt-10">
                    <section className="grid min-w-0 grid-cols-1 sm:px-0 px-4 items-center gap-8 lg:grid-cols-[minmax(0,1.18fr)_minmax(700px,0.82fr)] lg:gap-12">
                        <div className="order-2 lg:order-1 min-w-0 lg:col-start-1 lg:row-start-1">

                            <div className="sm:text-right text-center">
                                <span className="inline-flex rounded-lg bg-[#224CDF] px-3.5 py-2 text-xs font-black text-white shadow-lg shadow-violet-600/15">
                                    دوره تخصصی
                                </span>
                            </div>

                            <div className="mt-5 sm:text-right text-center">
                                <h1>
                                    <span className="block text-3xl font-black leading-tight text-[#224CDF] sm:text-4xl lg:text-[48px]">
                                        دوره تخصصی
                                    </span>
                                    {" "}
                                    <span className="mt-3 block text-4xl font-black leading-[1.35] tracking-tight text-slate-950 sm:text-5xl lg:text-[56px]">
                                        تربیت معلم هوش
                                    </span>
                                </h1>
                            </div>

                            <div className="mt-6 flex items-center gap-3 text-xl font-black text-[#224CDF] sm:text-2xl sm:justify-start justify-center">
                                <Icon name="user" className="h-7 w-7 shrink-0" />
                                <span>استاد داریوش دارابی</span>
                            </div>

                            <div className="mt-8 gap-3 grid sm:grid-cols-4 grid-cols-2">
                                {courseStats.map((stat, index) => (
                                    <div
                                        key={stat.value}
                                        className={`flex sm:flex-col sm:justify-center sm:text-center min-w-0 items-center gap-3 rounded-2xl border border-slate-100 bg-white/80 px-3 py-4 backdrop-blur-sm ${index < courseStats.length - 1
                                            ? "sm:border-l-slate-200"
                                            : ""
                                            }`}
                                    >
                                        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-violet-50 text-[#3153A4]">
                                            <Icon name={stat.icon} className="h-5 w-5" />
                                        </div>

                                        <div className="min-w-0">
                                            <div className="text-xs font-black text-[#3153A4]">
                                                {stat.value}
                                            </div>
                                            <div className="mt-1 text-xs leading-5 text-slate-500">
                                                {stat.label}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="order-1 lg:order-2 min-w-0 lg:col-start-2 lg:row-start-1">
                            <div className="relative aspect-video overflow-hidden rounded-[18px] bg-slate-950">
                                {videoSrc ? (
                                    <iframe
                                        src={videoSrc}
                                        className="h-full w-full"
                                        allowFullScreen
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        title="ویدیو معرفی دوره"
                                    />
                                ) : (
                                    <>
                                        <Image
                                            src={posterSrc}
                                            alt="پوستر ویدیوی معرفی دوره تخصصی تربیت معلم هوش"
                                            className="h-full w-full object-cover"
                                        />

                                        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-slate-950/35 via-transparent to-transparent" />

                                        <div
                                            aria-hidden="true"
                                            className="pointer-events-none absolute inset-0 flex items-center justify-center"
                                        >
                                            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/90 text-slate-900 shadow-2xl backdrop-blur sm:h-20 sm:w-20">
                                                <Icon
                                                    name="play"
                                                    className="h-9 w-9 sm:h-11 sm:w-11"
                                                    strokeWidth={1.6}
                                                />
                                            </div>
                                        </div>

                                        <div className="pointer-events-none absolute inset-x-4 bottom-3 flex items-center gap-3 text-xs text-white">
                                            <span>۰:۰۰ / ۱:۳۵</span>
                                            <div className="h-1 flex-1 overflow-hidden rounded-full bg-white/40">
                                                <div className="h-full w-[12%] rounded-full bg-white" />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </section>

                    {!isExpired && (
                        <section className="mx-auto my-16">
                            <div className="bg-[#F6F7FE] py-5 px-10 max-w-230 mx-auto rounded-2xl shadow-xl">
                                <div className="flex gap-12 justify-center">
                                    <div className="space-y-4">
                                        <h2 className="text-[#2C42C8] font-bold text-center text-2xl">ثبت‌نام رایگان در وبینار معرفی دوره تربیت معلم هوش</h2>
                                        <div className="flex relative">
                                            <p className="text-[#504f55] text-center">جلسه اول دوره با استاد داریوش دارابی در تاریخ شنبه 14 شهریور ساعت 20:30 برگزار میشود.</p>
                                            <Image className="w-10 h-10 absolute -left-8 top-5 lg:block hidden" src={flash} alt="flash" />
                                        </div>
                                        {isLoggedIn ? (
                                            <button
                                                onClick={() => handleOpenConferenceModal()}
                                                className="
                                                flex
                                                cursor-pointer mx-auto
                                                gap-2
                                                bg-[#2B52E6]
                                                p-3
                                                w-72
                                                justify-center
                                                text-white
                                                rounded-2xl
                                                items-center
                                                transition-all
                                                duration-300
                                                ease-out
                                                hover:scale-105
                                                hover:shadow-[0_8px_25px_rgba(43,82,230,0.35)]
                                                active:scale-95
                                            "
                                            >
                                                <Calendar1 className="transition-transform duration-300 group-hover:rotate-6" />
                                                ثبت‌نام وبینار رایگان
                                            </button>
                                        ) : (
                                            <AuthStepController
                                                id="teacher-training-course"
                                                triggerButton={
                                                    <button
                                                        onClick={() => window.location.hash = "conference-modal"}
                                                        className="
                                                        flex
                                                        cursor-pointer mx-auto
                                                        gap-2
                                                        bg-[#2B52E6]
                                                        p-3
                                                        w-72
                                                        justify-center
                                                        text-white
                                                        rounded-2xl
                                                        items-center
                                                        transition-all
                                                        duration-300
                                                        ease-out
                                                        hover:scale-105
                                                        hover:shadow-[0_8px_25px_rgba(43,82,230,0.35)]
                                                        active:scale-95
                                                    "
                                                    >
                                                        <Calendar1 className="transition-transform duration-300 group-hover:rotate-6" />
                                                        ثبت‌نام وبینار رایگان
                                                    </button>

                                                } />
                                        )}
                                    </div>

                                    <div className="lg:block hidden">
                                        <Image className="w-40 h-36" src={taghvim} alt="taghvim" />
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}

                    <div className="mt-12 sm:mt-16">
                        <SectionHeading>درباره دوره تخصصی تربیت معلم هوش</SectionHeading>
                    </div>

                    <section className="hidden lg:block relative mt-8 overflow-hidden rounded-[24px] border border-slate-200 bg-white px-5 py-6 shadow-[0_14px_50px_rgba(15,23,42,0.055)] sm:px-8 sm:py-8 lg:mt-10 lg:px-10">
                        <div className="flex gap-5">
                            <div className="hidden lg:flex items-center justify-center ">
                                <div className="relative flex w-full items-center justify-center gap-11 lg:flex-col lg:justify-between">
                                    <div className="absolute left-[16%] right-[16%] top-1/2 hidden -translate-y-1/2 border-t-2 border-dotted border-slate-200 sm:block lg:bottom-[16%] lg:left-1/2 lg:right-auto lg:top-[16%] lg:h-auto lg:-translate-x-1/2 lg:translate-y-0 lg:border-l-2 lg:border-t-0" />

                                    <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-[#004e89] text-white shadow-lg shadow-violet-600/20 sm:h-14 sm:w-14">
                                        <Icon name="book" className="h-6 w-6 sm:h-7 sm:w-7" />
                                    </div>

                                    <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-[#00a8e8] text-white shadow-lg shadow-amber-400/20 sm:h-14 sm:w-14">
                                        <Icon
                                            name="target"
                                            className="h-6 w-6 sm:h-7 sm:w-7"
                                        />
                                    </div>

                                    <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-[#007ea7] text-white shadow-lg shadow-sky-500/20 sm:h-14 sm:w-14">
                                        <Icon
                                            name="users"
                                            className="h-6 w-6 sm:h-7 sm:w-7"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="min-w-0 space-y-5 text-justify text-sm font-medium leading-9 text-slate-700 sm:text-base sm:leading-10">
                                <p>
                                    یک معلم خوب فقط سال جاری آموزشی را نمی‌بیند و
                                    همیشه به آینده بچه‌ها و دانش‌آموزان خود فکر
                                    می‌کند. خیلی‌ها تصور می‌کنند فقط بلد بودن مباحث
                                    تدریس کافی است، اما واقعیت ماجرا فراتر از این
                                    حرف‌ها است. چیزی که تفاوت یک مدرس معمولی با یک
                                    مدرس حرفه‌ای را رقم می‌زند، نحوه انتقال، مدیریت
                                    کلاس و مسیری است که برای آموزش طراحی می‌کند.
                                </p>

                                <p>
                                    دوره تخصصی تربیت معلم آموزگار هوش با تدریس استاد
                                    داریوش دارابی، با هدف آموزش همین مهارت‌ها طراحی
                                    شده است. این دوره حاصل سال‌ها تجربه تدریس، تألیف
                                    کتاب‌های آموزشی مختلف و فعالیت در حوزه آموزش هوش
                                    و تیزهوشان است و تلاش می‌کند تجربه‌های عملی و
                                    کاربردی را در اختیار شرکت‌کنندگان قرار دهد.
                                </p>

                                <p>
                                    این دوره برای معلمان ریاضی، مدرسان هوش، مدیران
                                    مدارس، فعالان حوزه تیزهوشان، دانشجویان رشته‌های
                                    مرتبط و افرادی که قصد دارند به‌صورت حرفه‌ای وارد
                                    آموزش مهارت‌های هوش شوند، انتخابی مناسب خواهد بود.
                                </p>
                            </div>
                        </div>
                    </section>

                    <section className="lg:hidden block sm:px-0 px-4 relative mt-8 overflow-hidden sm:px-8 sm:py-8 lg:mt-10 lg:px-10">
                        <div className="flex gap-5">
                            <div className="min-w-0 space-y-5 text-justify text-sm font-medium leading-9 text-slate-700 sm:text-base sm:leading-10">
                                <div className="space-y-6 rounded-[24px] border border-slate-200 bg-white px-5 py-6 shadow-[0_14px_50px_rgba(15,23,42,0.055)]">
                                    <div className="relative z-10 flex h-12 w-12 items-center mx-auto justify-center rounded-full bg-violet-600 text-white shadow-lg shadow-violet-600/20 sm:h-14 sm:w-14">
                                        <Icon name="book" className="h-6 w-6 sm:h-7 sm:w-7" />
                                    </div>
                                    <p className="text-center">
                                        یک معلم خوب فقط سال جاری آموزشی را نمی‌بیند و
                                        همیشه به آینده بچه‌ها و دانش‌آموزان خود فکر
                                        می‌کند. خیلی‌ها تصور می‌کنند فقط بلد بودن مباحث
                                        تدریس کافی است، اما واقعیت ماجرا فراتر از این
                                        حرف‌ها است. چیزی که تفاوت یک مدرس معمولی با یک
                                        مدرس حرفه‌ای را رقم می‌زند، نحوه انتقال، مدیریت
                                        کلاس و مسیری است که برای آموزش طراحی می‌کند.
                                    </p>
                                </div>
                                <div className="space-y-6 rounded-[24px] border border-slate-200 bg-white px-5 py-6 shadow-[0_14px_50px_rgba(15,23,42,0.055)]">
                                    <div className="relative z-10 flex h-12 w-12 items-center mx-auto justify-center rounded-full bg-amber-400 text-white shadow-lg shadow-amber-400/20 sm:h-14 sm:w-14">
                                        <Icon
                                            name="target"
                                            className="h-6 w-6 sm:h-7 sm:w-7"
                                        />
                                    </div>
                                    <p className="text-center">
                                        دوره تخصصی تربیت معلم آموزگار هوش با تدریس استاد
                                        داریوش دارابی، با هدف آموزش همین مهارت‌ها طراحی
                                        شده است. این دوره حاصل سال‌ها تجربه تدریس، تألیف
                                        کتاب‌های آموزشی مختلف و فعالیت در حوزه آموزش هوش
                                        و تیزهوشان است و تلاش می‌کند تجربه‌های عملی و
                                        کاربردی را در اختیار شرکت‌کنندگان قرار دهد.
                                    </p>
                                </div>

                                <div className="space-y-6 rounded-[24px] border border-slate-200 bg-white px-5 py-6 shadow-[0_14px_50px_rgba(15,23,42,0.055)]">
                                    <div className="relative z-10 flex h-12 w-12 items-center mx-auto justify-center rounded-full bg-sky-500 text-white shadow-lg shadow-sky-500/20 sm:h-14 sm:w-14">
                                        <Icon
                                            name="users"
                                            className="h-6 w-6 sm:h-7 sm:w-7"
                                        />
                                    </div>
                                    <p className="text-center">
                                        این دوره برای معلمان ریاضی، مدرسان هوش، مدیران
                                        مدارس، فعالان حوزه تیزهوشان، دانشجویان رشته‌های
                                        مرتبط و افرادی که قصد دارند به‌صورت حرفه‌ای وارد
                                        آموزش مهارت‌های هوش شوند، انتخابی مناسب خواهد بود.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section>
                        <div className="bg-[#3F6CE7] w-full mt-10 block md:hidden py-4">
                            <div className="flex items-center justify-between px-4 mb-3">
                                <span className="text-white text-sm">
                                    ویدیوهای بیشتر
                                </span>

                                <span className="text-white/70 text-xs">
                                    ← بکشید
                                </span>
                            </div>

                            <div
                                className="flex gap-4 overflow-x-auto snap-x snap-mandatory px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
                            >
                                {bebgoroVeidos.map(({ iframe }, i) => (
                                    <div
                                        key={i}
                                        className="shrink-0 w-[82%] aspect-video rounded-[10px] overflow-hidden border border-white/20 snap-center"
                                    >
                                        <iframe
                                            className="w-full h-full"
                                            src={iframe}
                                            allowFullScreen
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <DesktopVideoPlayList />
                    </section>

                    <section className="relative mt-12 sm:mt-16 -mx-10 sm:px-0 px-4">
                        <SectionHeading>سرفصل‌ها و امکانات دوره</SectionHeading>

                        <div className="min-w-0 flex flex-wrap gap-5 justify-center">
                            {courseFeatures.map((feature) => (
                                <div key={feature.title} className="sm:basis-1/4 basis-10/12 shrink-0">
                                    <FeatureCard key={feature.title} feature={feature} />
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="relative mt-14 sm:mt-16 sm:px-0 px-4">
                        <div className="pointer-events-none absolute -left-20 top-8 -z-10 h-64 w-64 rounded-full bg-violet-100/60 blur-3xl" />
                        <SectionHeading>گواهینامه پایان دوره</SectionHeading>
                        <div className="hidden lg:block pointer-events-none absolute right-0 top-1/2 -translate-y-1/1 translate-x-1/1 xl:translate-x-1/1 2xl:translate-x-1/3">
                            <Image
                                src={pencel}
                                alt="pencil"
                                className="h-auto w-40 sm:w-48 lg:w-56 xl:w-64 2xl:w-72 rotate-180"
                            />
                        </div>
                        <div className="mx-auto max-w-6xl flex flex-col g ap-5">
                            <div className="sm:-space-y-0 space-y-3 grid sm:grid-cols-3 gap-5 grid-cols-1 items-center">
                                <article className="relative overflow-hidden rounded-[22px] border border-[#CCE0FF] bg-gradient-to-l from-[#E5F0FF] to-white p-5 sm:p-7">
                                    <div className="pointer-events-none absolute -left-12 -top-12 h-40 w-40 rounded-full border-[24px] border-[#E5F0FF]/70" />
                                    <div className="relative flex sm:flex-col items-center gap-6 sm:justify-center justify-between">
                                        <div className="bg-blue-200/65 p-5 rounded-2xl border border-[#b6d2fd]">
                                            <Image src={shiraz} alt="shiraz" className="sm:w-30 w-15 h-15 sm:h-30" />
                                        </div>
                                        <div className="min-w-0 text-center space-y-2">
                                            <h3 className="text-base font-black leading-8 text-slate-900 sm:text-2xl">
                                                <span className="block">گواهینامه معتبر</span>
                                                <span className="block">دانشگاه سراسری شیراز</span>
                                            </h3>
                                        </div>
                                    </div>
                                </article>
                                <article className="relative overflow-hidden rounded-[22px] border border-[#CCE0FF] bg-gradient-to-l from-[#E5F0FF] to-white p-5 sm:p-7">
                                    <div className="pointer-events-none absolute -left-12 -top-12 h-40 w-40 rounded-full border-[24px] border-[#E5F0FF]/70" />
                                    <div className="relative flex sm:flex-col items-center gap-6 sm:justify-center justify-between">
                                        <div className="bg-blue-200/65 p-5 rounded-2xl border border-[#b6d2fd]">
                                            <Image src={saminIcon} alt="shiraz" className="sm:w-30 w-15 h-15 sm:h-30" />
                                        </div>
                                        <div className="min-w-0 text-center space-y-2">
                                            <h3 className="text-base font-black leading-8 text-slate-900 sm:text-2xl">
                                                <span className="block">دریافت مدرک</span>
                                                <span className="block">شرکت مهندسی ثمین تراشه</span>
                                            </h3>
                                        </div>
                                    </div>
                                </article>
                                <article className="relative overflow-hidden rounded-[22px] border border-blue-200 bg-gradient-to-l from-blue-50 to-white p-5 sm:p-7">
                                    <div className="pointer-events-none absolute -left-12 -top-12 h-40 w-40 rounded-full border-[24px] border-blue-100/70" />
                                    <div className="relative flex sm:flex-col items-center gap-3 sm:justify-center justify-between">
                                        <div className="bg-blue-200/65 p-5 rounded-2xl border border-[#b6d2fd]">
                                            <Image src={farhangiyan} alt="farhangiyan" className="sm:w-32 w-15 h-15 sm:h-32" />
                                        </div>
                                        <div className="min-w-0 text-center space-y-2">
                                            <h3 className="text-base font-black leading-8 text-slate-900 sm:text-2xl">
                                                <span className="block">گواهینامه معتبر</span>
                                                <span className="block">ضمن خدمت فرهنگیان</span>
                                            </h3>
                                        </div>
                                    </div>
                                </article>
                            </div>
                            <div className="sm:max-w-4xl max-w-xs mx-auto mt-12">
                                <Swiper
                                    modules={[Navigation, Pagination, Autoplay]}
                                    spaceBetween={50}
                                    slidesPerView={1}
                                    pagination={{ clickable: true }}
                                    autoplay={{
                                        delay: 6000,
                                    }}
                                    className="px-3 sm:px-12 !pb-7 sm:!pb-8">
                                    <SwiperSlide>
                                        <Image
                                            src={madrak_1}
                                            alt="shiraz"
                                            className="w-full h-full rounded-3xl object-cover"
                                        />
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <Image
                                            src={madrak_2}
                                            alt="samin"
                                            className="w-full h-full rounded-3xl object-cover"
                                        />
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                            <div className="hidden lg:block pointer-events-none absolute left-0 -bottom-3 -translate-x-1/3">
                                <Image
                                    src={goniya}
                                    alt="triangle"
                                    className="h-auto w-28 sm:w-32 md:w-36 lg:w-40 xl:w-44 rotate-[20deg]"
                                />
                            </div>
                        </div>

                        <div className="mt-5 flex items-center justify-center gap-3 text-center text-sm font-bold leading-7 text-slate-600 sm:text-base">
                            <Icon
                                name="certificate"
                                className="h-7 w-7 shrink-0 text-[#224CDF] hidden lg:block"
                            />
                            <p className="sm:max-w-max max-w-80">
                                پس از انجام پروژه پایانی و تکمیل تکالیف، گواهینامه
                                پایان دوره ارائه می‌شود.
                            </p>
                        </div>
                    </section>

                    <section className="mt-14 sm:mt-16 sm:px-0 px-4">
                        <div className="overflow-hidden rounded-[24px] border-2 border-dashed border-[#224CDF] bg-white p-5 shadow-[0_16px_50px_rgba(109,40,217,0.06)] sm:p-8">
                            <SectionHeading>
                                پرداخت اقساطی و مشاوره
                            </SectionHeading>

                            <p className="-mt-2 text-center text-sm font-medium leading-7 text-slate-600 sm:text-base">
                                در صورت تمایل به پرداخت اقساطی، لطفاً با یکی از
                                شماره‌های زیر تماس بگیرید:
                            </p>

                            <div className="mt-6 grid grid-cols-1 gap-3 md:grid-cols-3">
                                {contactNumbers.map((phone) => (
                                    <a
                                        key={phone}
                                        href={`tel:${phone
                                            .replace(/[۰-۹]/g, (character) =>
                                                String("۰۱۲۳۴۵۶۷۸۹".indexOf(character)),
                                            )
                                            .replace(/-/g, "")}`}
                                        className="group flex min-h-14 items-center justify-center gap-4 rounded-2xl border border-slate-200 bg-white px-4 text-center text-base font-black text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:border-violet-300 hover:text-[#224CDF] hover:shadow-lg"
                                    >
                                        <span dir="ltr">{phone}</span>

                                        <Icon
                                            name="phone"
                                            className="h-5 w-5 text-[#224CDF] transition group-hover:rotate-[-8deg]"
                                        />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </section>

                    <div className="pointer-events-none absolute bottom-0 left-0 -z-10 h-72 w-72 -translate-x-1/3 translate-y-1/3 rounded-full bg-violet-100/80 blur-3xl" />

                    <div className="sticky bottom-20 z-40 mx-auto mt-6 w-full max-w-[1160px] sm:bottom-3.5 sm:px-0 px-4">
                        <RegistrationButton />
                    </div>
                </div>
            </main>

            <RegistrationModal
                open={registrationOpen}
                onClose={() => setRegistrationOpen(false)}
                onSubmitRegistration={onSubmitRegistration}
            />

            <SuccessModal
                open={registrationOpenConference}
                onClose={() => setRegistrationOpenConference(false)}
            />
        </>
    );
}
